import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";

const DeleteSeller = (props) => {
    const submit = props.submit
    const getData = props.getData
    const modal3 = props.modal3
    const setModal3 = props.setModal3
    const id = props.id

    const cancelDelete = (e) => {
        e.preventDefault();
        setModal3(!modal3)
    }

    const submitData = (e) => {
        console.log("sending delete req")
        console.log(id)
        e.preventDefault()

        let data = axios.delete(`/api/sellers`, { data: { ids: [id] },
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            }
        })
            .then(response => {
                showSuccessToast((response.data && response.data.Message) ? response.data.Message : "Success")
                getData()
            })
            .catch(error => {
                
                console.error('Error making POST request:', error);
                showErrorToast("Error")
            });
        setModal3(!modal3)

    }



    return (
        <div>
            <Modal size="md" isOpen={modal3} toggle={() => setModal3(!modal3)}>
                <ModalHeader toggle={() => setModal3(!modal3)}>
                    Delete Seller
                </ModalHeader>
                <ModalBody>
                    <form >
                        <div className="text-center">
                            Are you sure you want to delete?
                        </div>
                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn bg-gradient-secondary w-30 my-5 mb-2 m-2"
                                onClick={(e) => cancelDelete(e)}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn bg-gradient-info  w-30 my-5 mb-2"
                                onClick={(e) => submitData(e)}
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default DeleteSeller;
